import React, { useState } from 'react';

import AccessCodeUsageSchool from '../../components/Reports/AccessCodeUsageSchool';
import AccessCodeUsageBook from '../../components/Reports/AccessCodeUsageBook';
import AccessCodeUsagePublisher from '../../components/Reports/AccessCodeUsagePublisher';
import AccessCodeUsageBatch from '../../components/Reports/AccessCodeUsageBatch';
import TopDownloadedBooks from '../../components/Reports/TopDownloadedBooks';

import styles from './Reports.module.css'; 
import SalesByPublisher from '../../components/Reports/SalesByPublisher';

const ReportWeb: React.FC = () => {



    return (
        <div className={styles.container}>
    
            <div className={styles.content2}>
                <AccessCodeUsageBook website={true}/>
                <AccessCodeUsagePublisher website={true}/>
                <SalesByPublisher/>
                {/* <TopDownloadedBooks/> */}
                
            </div>
          
           
        </div>
    );
}

export default ReportWeb;
